import { render, staticRenderFns } from "./GameDetail.vue?vue&type=template&id=9c251ca4&scoped=true&"
import script from "./GameDetail.vue?vue&type=script&lang=js&"
export * from "./GameDetail.vue?vue&type=script&lang=js&"
import style0 from "./GameDetail.vue?vue&type=style&index=0&id=9c251ca4&lang=scss&scoped=true&"
import style1 from "./GameDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c251ca4",
  null
  
)

export default component.exports